import { Space, Typography, Button } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { GeneralContentWrapper } from '../../components/Shared/GeneralComponents'
import { useStores } from '../../cls/stores/MobXProvider'
import { observer } from 'mobx-react-lite'
import { useSmartTranslation } from '../../cls/TranslationContext'

const { Title, Paragraph } = Typography

/**
 * Page404 Component
 *
 * Displays a 404 error message when a page is not found. Includes navigation
 * links to the homepage and (optionally) the dashboard if the user is logged in.
 *
 * @returns {JSX.Element} The rendered Page404 component.
 */
const Page404 = observer(() => {
	const { t } = useSmartTranslation()
	const { users } = useStores()
	const navigate = useNavigate()

	return (
		<GeneralContentWrapper>
			<Space
				style={{ width: '100%' }}
				direction="vertical"
				align="center"
			>
				<Title
					level={1}
					style={{
						fontSize: '100px',
						fontWeight: 'bold',
						textAlign: 'center'
					}}
				>
					404
				</Title>
				<Paragraph style={{ fontSize: '18px', textAlign: 'center' }}>
					You didn't break the internet, but we can't find what you
					are looking for.
				</Paragraph>
				<Space direction="horizontal" size="middle">
					<Button
						type="primary"
						onClick={() => navigate('/', { replace: true })}
					>
						{t('single.go-to')} {t('single.homepage')}
					</Button>
					{users.isLoggedIn && (
						<Button
							type="default"
							onClick={() => navigate('/dashboard')}
						>
							{t('single.go-to')} {t('single.dashbord')}
						</Button>
					)}
				</Space>
			</Space>
		</GeneralContentWrapper>
	)
})

export default Page404
